export default __webpack_public_path__ + "static/breadcrumbs-distinguishable-labels-do-dark-1370ba69729570e543fbf4fd19ce5000.png";